// extracted by mini-css-extract-plugin
export var brand = "_54-9";
export var compact = "_54-6";
export var extraSmall = "_54-7";
export var icon = "_54-0";
export var large = "_54-4";
export var light = "_54-1";
export var medium = "_54-5";
export var outline = "_54-b";
export var primaryDark = "_54-a";
export var primaryLight = "_54-8";
export var primaryModern = "_54-c";
export var success = "_54-2";
export var successSolid = "_54-3";